import { Property, BaseModel } from '@red/core';
import { Address, COMPANY_STATUS, COMPANY_PERIOD_INTERVAL, SieValidatedFiscalYear, Amount, Stock, Shareholder, COUNTRY, COMPANY_FISCAL_YEAR_LENGTH } from '@red/data';

var ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE$1;
(function (ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE) {
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["CEO"] = "CEO";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["BOARD_MEMBER"] = "BOARD_MEMBER";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["CHAIRMAN"] = "CHAIRMAN";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["ALTERNATE_MEMBER"] = "ALTERNATE_MEMBER";
})(ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE$1 || (ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE$1 = {}));

var __decorate$13 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$13 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationBoardMember$1 extends BaseModel {
}
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], OnboardingApplicationBoardMember$1.prototype, "identifier", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], OnboardingApplicationBoardMember$1.prototype, "firstName", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", String)
], OnboardingApplicationBoardMember$1.prototype, "lastName", void 0);
__decorate$13([
    Property({ type: ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE$1 }),
    __metadata$13("design:type", String)
], OnboardingApplicationBoardMember$1.prototype, "role", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Boolean)
], OnboardingApplicationBoardMember$1.prototype, "isCeo", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Boolean)
], OnboardingApplicationBoardMember$1.prototype, "isChairman", void 0);
__decorate$13([
    Property(),
    __metadata$13("design:type", Address)
], OnboardingApplicationBoardMember$1.prototype, "address", void 0);

var __decorate$12 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$12 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationBusinessOperationCode$1 extends BaseModel {
}
__decorate$12([
    Property(),
    __metadata$12("design:type", String)
], OnboardingApplicationBusinessOperationCode$1.prototype, "businessOperationCode", void 0);
__decorate$12([
    Property(),
    __metadata$12("design:type", Number)
], OnboardingApplicationBusinessOperationCode$1.prototype, "revenue", void 0);

class OnboardingApplicationData$1 extends BaseModel {
    validate() {
        return null;
    }
}

class OnboardingApplicationDataValidationError$1 {
    constructor() {
        this._errors = {};
    }
    requireTrue(key, data) {
        if (data[key] !== true) {
            this._errors[key] = `ValidationError: ${key} is not true`;
        }
    }
    hasErrors() {
        return Object.keys(this._errors).length !== 0;
    }
    toString() {
        return Object.values(this._errors).join(',');
    }
}

var __decorate$11 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$11 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataTermsOfService$1 extends OnboardingApplicationData$1 {
    validate() {
        const err = new OnboardingApplicationDataValidationError$1();
        err.requireTrue('termsAndConditions', this);
        // err.requireTrue('creditCardAgreement', this);
        return err.hasErrors() ? err : null;
    }
}
__decorate$11([
    Property(),
    __metadata$11("design:type", Boolean)
], OnboardingApplicationDataTermsOfService$1.prototype, "termsAndConditions", void 0);
__decorate$11([
    Property(),
    __metadata$11("design:type", Boolean)
], OnboardingApplicationDataTermsOfService$1.prototype, "creditCardAgreement", void 0);
__decorate$11([
    Property(),
    __metadata$11("design:type", String)
], OnboardingApplicationDataTermsOfService$1.prototype, "voucherCode", void 0);

var __decorate$10 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$10 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingActivate$1 extends OnboardingApplicationData$1 {
}
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], OnboardingApplicationDataExistingActivate$1.prototype, "companyId", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], OnboardingApplicationDataExistingActivate$1.prototype, "employerPermitGranted", void 0);
__decorate$10([
    Property({ type: COMPANY_STATUS }),
    __metadata$10("design:type", String)
], OnboardingApplicationDataExistingActivate$1.prototype, "companyStatus", void 0);
__decorate$10([
    Property(),
    __metadata$10("design:type", String)
], OnboardingApplicationDataExistingActivate$1.prototype, "vatStartDate", void 0);
__decorate$10([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$10("design:type", String)
], OnboardingApplicationDataExistingActivate$1.prototype, "vatInterval", void 0);

var __decorate$$ = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$$ = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingCompanyInfo$1 extends OnboardingApplicationData$1 {
}
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "companyIdentifier", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "companyName", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "companyDescription", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "firstFiscalYearStartDate", void 0);
__decorate$$([
    Property(),
    __metadata$$("design:type", Address)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "address", void 0);
__decorate$$([
    Property({ type: OnboardingApplicationBusinessOperationCode$1 }),
    __metadata$$("design:type", Array)
], OnboardingApplicationDataExistingCompanyInfo$1.prototype, "businessOperationCodes", void 0);

var ONBOARDING_SIE_STATUS$1;
(function (ONBOARDING_SIE_STATUS) {
    ONBOARDING_SIE_STATUS["OK"] = "OK";
    ONBOARDING_SIE_STATUS["ERROR"] = "ERROR";
})(ONBOARDING_SIE_STATUS$1 || (ONBOARDING_SIE_STATUS$1 = {}));

var __decorate$_ = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$_ = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingCreateCompany$1 extends OnboardingApplicationData$1 {
}
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "companyId", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "companyName", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "companyIdentifier", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "companyDescription", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "businessOperationCode", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "firstFiscalYearStartDate", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", Boolean)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "kycCheck", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", Boolean)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "rdcCheck", void 0);
__decorate$_([
    Property(),
    __metadata$_("design:type", Address)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "address", void 0);
__decorate$_([
    Property({ type: SieValidatedFiscalYear }),
    __metadata$_("design:type", Array)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "fiscalYears", void 0);
__decorate$_([
    Property({ type: ONBOARDING_SIE_STATUS$1 }),
    __metadata$_("design:type", String)
], OnboardingApplicationDataExistingCreateCompany$1.prototype, "sieStatus", void 0);

var __decorate$Z = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Z = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcExistingDocuments$1 extends OnboardingApplicationData$1 {
}
__decorate$Z([
    Property(),
    __metadata$Z("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments$1.prototype, "corporateRegistrationAssetId", void 0);
__decorate$Z([
    Property(),
    __metadata$Z("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments$1.prototype, "corporateRegistrationRecordAssetId", void 0);
__decorate$Z([
    Property(),
    __metadata$Z("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments$1.prototype, "annualReportAssetId", void 0);

var __decorate$Y = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Y = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingSettlement$1 extends OnboardingApplicationData$1 {
}
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], OnboardingApplicationDataExistingSettlement$1.prototype, "companyId", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", String)
], OnboardingApplicationDataExistingSettlement$1.prototype, "ocr", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", Amount)
], OnboardingApplicationDataExistingSettlement$1.prototype, "settlementAmount", void 0);
__decorate$Y([
    Property(),
    __metadata$Y("design:type", Amount)
], OnboardingApplicationDataExistingSettlement$1.prototype, "receivedSettlementAmount", void 0);

var __decorate$X = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$X = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingSie$1 extends OnboardingApplicationData$1 {
}
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], OnboardingApplicationDataExistingSie$1.prototype, "sieAssetId", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], OnboardingApplicationDataExistingSie$1.prototype, "fiscalYearStartDate", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], OnboardingApplicationDataExistingSie$1.prototype, "fiscalYearEndDate", void 0);
__decorate$X([
    Property(),
    __metadata$X("design:type", String)
], OnboardingApplicationDataExistingSie$1.prototype, "companyIdentifier", void 0);
__decorate$X([
    Property({ type: String }),
    __metadata$X("design:type", Array)
], OnboardingApplicationDataExistingSie$1.prototype, "errors", void 0);
__decorate$X([
    Property({ type: ONBOARDING_SIE_STATUS$1 }),
    __metadata$X("design:type", String)
], OnboardingApplicationDataExistingSie$1.prototype, "sieStatus", void 0);

var __decorate$W = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$W = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewActivate$1 extends OnboardingApplicationData$1 {
}
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "companyId", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "companyIdentifier", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "companyName", void 0);
__decorate$W([
    Property({ type: COMPANY_STATUS }),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "companyStatus", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "fiscalYearStartDate", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "fiscalYearEndDate", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "employerPermitGranted", void 0);
__decorate$W([
    Property(),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "vatStartDate", void 0);
__decorate$W([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$W("design:type", String)
], OnboardingApplicationDataLlcNewActivate$1.prototype, "vatInterval", void 0);

var __decorate$V = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$V = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewApplicationBlv$1 extends OnboardingApplicationData$1 {
}
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv$1.prototype, "companyName", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv$1.prototype, "companyRegistrationAssetId", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv$1.prototype, "blvAckAssetId", void 0);
__decorate$V([
    Property(),
    __metadata$V("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv$1.prototype, "blvCaseNumber", void 0);

var __decorate$U = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$U = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewApplicationSkv$1 extends OnboardingApplicationData$1 {
}
__decorate$U([
    Property(),
    __metadata$U("design:type", String)
], OnboardingApplicationDataLlcNewApplicationSkv$1.prototype, "companyStartDate", void 0);
__decorate$U([
    Property(),
    __metadata$U("design:type", String)
], OnboardingApplicationDataLlcNewApplicationSkv$1.prototype, "skvAckAssetId", void 0);

var __decorate$T = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$T = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvBoardForm$1 extends OnboardingApplicationData$1 {
}
__decorate$T([
    Property({ type: OnboardingApplicationBoardMember$1 }),
    __metadata$T("design:type", Array)
], OnboardingApplicationDataLlcNewBlvBoardForm$1.prototype, "boardMembers", void 0);

var __decorate$S = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$S = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvForm$1 extends OnboardingApplicationData$1 {
}
__decorate$S([
    Property(),
    __metadata$S("design:type", String)
], OnboardingApplicationDataLlcNewBlvForm$1.prototype, "email", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Address)
], OnboardingApplicationDataLlcNewBlvForm$1.prototype, "address", void 0);
__decorate$S([
    Property({ type: String }),
    __metadata$S("design:type", Array)
], OnboardingApplicationDataLlcNewBlvForm$1.prototype, "nameSuggestions", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Boolean)
], OnboardingApplicationDataLlcNewBlvForm$1.prototype, "isCEO", void 0);
__decorate$S([
    Property(),
    __metadata$S("design:type", Boolean)
], OnboardingApplicationDataLlcNewBlvForm$1.prototype, "isBeneficialOwner", void 0);

var __decorate$R = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$R = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvSharesForm$1 extends OnboardingApplicationData$1 {
}
__decorate$R([
    Property(),
    __metadata$R("design:type", Stock)
], OnboardingApplicationDataLlcNewBlvSharesForm$1.prototype, "stock", void 0);
__decorate$R([
    Property({ type: Shareholder }),
    __metadata$R("design:type", Array)
], OnboardingApplicationDataLlcNewBlvSharesForm$1.prototype, "shareholders", void 0);

var __decorate$Q = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Q = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewCreateCompany$1 extends OnboardingApplicationData$1 {
}
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "companyId", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "companyIdentifier", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "companyName", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "companyDescription", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "registrationDate", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "kycCheck", void 0);
__decorate$Q([
    Property(),
    __metadata$Q("design:type", Boolean)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "rdcCheck", void 0);
__decorate$Q([
    Property({ type: COUNTRY }),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "companyCountry", void 0);
__decorate$Q([
    Property({ type: COMPANY_FISCAL_YEAR_LENGTH }),
    __metadata$Q("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany$1.prototype, "firstFiscalYear", void 0);

var __decorate$P = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$P = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewShareCapital$1 extends OnboardingApplicationData$1 {
}
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "shareHolderCapital", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", Amount)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "receivedShareHolderCapital", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "ocr", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "companyId", void 0);
__decorate$P([
    Property(),
    __metadata$P("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "shareHolderNoteAssetId", void 0);
__decorate$P([
    Property({ type: String }),
    __metadata$P("design:type", Array)
], OnboardingApplicationDataLlcNewShareCapital$1.prototype, "listOfShareHolderNoteAssetIds", void 0);

var __decorate$O = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$O = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewSkvForm$1 extends OnboardingApplicationData$1 {
}
__decorate$O([
    Property(),
    __metadata$O("design:type", String)
], OnboardingApplicationDataLlcNewSkvForm$1.prototype, "companyDescription", void 0);
__decorate$O([
    Property({ type: OnboardingApplicationBusinessOperationCode$1 }),
    __metadata$O("design:type", Array)
], OnboardingApplicationDataLlcNewSkvForm$1.prototype, "businessOperationCodes", void 0);

var __decorate$N = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$N = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleExistingDocuments$1 extends OnboardingApplicationData$1 {
}
__decorate$N([
    Property(),
    __metadata$N("design:type", String)
], OnboardingApplicationDataSoleExistingDocuments$1.prototype, "corporateRegistrationRecordAssetId", void 0);

var __decorate$M = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$M = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewActivate$1 extends OnboardingApplicationData$1 {
}
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "companyId", void 0);
__decorate$M([
    Property({ type: COMPANY_STATUS }),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "companyStatus", void 0);
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "fiscalYearStartDate", void 0);
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "fiscalYearEndDate", void 0);
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "employerPermitGranted", void 0);
__decorate$M([
    Property(),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "vatStartDate", void 0);
__decorate$M([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$M("design:type", String)
], OnboardingApplicationDataSoleNewActivate$1.prototype, "vatInterval", void 0);

var __decorate$L = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$L = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewApplicationSkv$1 extends OnboardingApplicationData$1 {
}
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], OnboardingApplicationDataSoleNewApplicationSkv$1.prototype, "companyStartDate", void 0);
__decorate$L([
    Property(),
    __metadata$L("design:type", String)
], OnboardingApplicationDataSoleNewApplicationSkv$1.prototype, "skvAckAssetId", void 0);

var __decorate$K = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$K = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewCreateCompany$1 extends OnboardingApplicationData$1 {
}
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "companyId", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "companyIdentifier", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "companyName", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "companyDescription", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "registrationDate", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", Boolean)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "kycCheck", void 0);
__decorate$K([
    Property(),
    __metadata$K("design:type", Boolean)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "rdcCheck", void 0);
__decorate$K([
    Property({ type: COUNTRY }),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "companyCountry", void 0);
__decorate$K([
    Property({ type: COMPANY_FISCAL_YEAR_LENGTH }),
    __metadata$K("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany$1.prototype, "firstFiscalYear", void 0);

var __decorate$J = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$J = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewSkvForm$1 extends OnboardingApplicationData$1 {
}
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "companyDescription", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "previousSalary", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "previousTaxes", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "previousOtherIncome", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "salary", void 0);
__decorate$J([
    Property(),
    __metadata$J("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "otherIncome", void 0);
__decorate$J([
    Property({ type: OnboardingApplicationBusinessOperationCode$1 }),
    __metadata$J("design:type", Array)
], OnboardingApplicationDataSoleNewSkvForm$1.prototype, "businessOperationCodes", void 0);

var ONBOARDING_TRACK$1;
(function (ONBOARDING_TRACK) {
    ONBOARDING_TRACK["SOLE_TRADER_NEW"] = "SOLE_TRADER_NEW";
    ONBOARDING_TRACK["SOLE_TRADER_EXISTING"] = "SOLE_TRADER_EXISTING";
    ONBOARDING_TRACK["LIMITED_COMPANY_NEW"] = "LIMITED_COMPANY_NEW";
    ONBOARDING_TRACK["LIMITED_COMPANY_EXISTING"] = "LIMITED_COMPANY_EXISTING";
    ONBOARDING_TRACK["NONE"] = "NONE";
})(ONBOARDING_TRACK$1 || (ONBOARDING_TRACK$1 = {}));

var ONBOARDING_APPLICATION_TYPE$1;
(function (ONBOARDING_APPLICATION_TYPE) {
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_COMPANY_INFO"] = "LIMITED_COMPANY_EXISTING_COMPANY_INFO";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_DOCUMENTS"] = "LIMITED_COMPANY_EXISTING_DOCUMENTS";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_SIE"] = "LIMITED_COMPANY_EXISTING_SIE";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_CREATE_COMPANY"] = "LIMITED_COMPANY_EXISTING_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_SETTLEMENT"] = "LIMITED_COMPANY_EXISTING_SETTLEMENT";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_ACTIVATE"] = "LIMITED_COMPANY_EXISTING_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_FORM"] = "LIMITED_COMPANY_NEW_BLV_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_BOARD_FORM"] = "LIMITED_COMPANY_NEW_BLV_BOARD_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_SHARES_FORM"] = "LIMITED_COMPANY_NEW_BLV_SHARES_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_SKV_FORM"] = "LIMITED_COMPANY_NEW_SKV_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_SHARE_CAPITAL"] = "LIMITED_COMPANY_NEW_SHARE_CAPITAL";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_APPLICATION_BLV"] = "LIMITED_COMPANY_NEW_APPLICATION_BLV";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_APPLICATION_SKV"] = "LIMITED_COMPANY_NEW_APPLICATION_SKV";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_CREATE_COMPANY"] = "LIMITED_COMPANY_NEW_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_ACTIVATE"] = "LIMITED_COMPANY_NEW_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_COMPANY_INFO"] = "SOLE_TRADER_EXISTING_COMPANY_INFO";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_DOCUMENTS"] = "SOLE_TRADER_EXISTING_DOCUMENTS";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_SIE"] = "SOLE_TRADER_EXISTING_SIE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_CREATE_COMPANY"] = "SOLE_TRADER_EXISTING_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_SETTLEMENT"] = "SOLE_TRADER_EXISTING_SETTLEMENT";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_ACTIVATE"] = "SOLE_TRADER_EXISTING_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_SKV_FORM"] = "SOLE_TRADER_NEW_SKV_FORM";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_CREATE_COMPANY"] = "SOLE_TRADER_NEW_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_APPLICATION_SKV"] = "SOLE_TRADER_NEW_APPLICATION_SKV";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_ACTIVATE"] = "SOLE_TRADER_NEW_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
})(ONBOARDING_APPLICATION_TYPE$1 || (ONBOARDING_APPLICATION_TYPE$1 = {}));

var ONBOARDING_APPLICATION_STATUS$1;
(function (ONBOARDING_APPLICATION_STATUS) {
    ONBOARDING_APPLICATION_STATUS["DRAFT"] = "DRAFT";
    ONBOARDING_APPLICATION_STATUS["SENT"] = "SENT";
    ONBOARDING_APPLICATION_STATUS["DONE"] = "DONE";
})(ONBOARDING_APPLICATION_STATUS$1 || (ONBOARDING_APPLICATION_STATUS$1 = {}));

var __decorate$I = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$I = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationReference$1 extends BaseModel {
}
__decorate$I([
    Property(),
    __metadata$I("design:type", String)
], OnboardingApplicationReference$1.prototype, "applicationId", void 0);
__decorate$I([
    Property({ type: ONBOARDING_APPLICATION_TYPE$1 }),
    __metadata$I("design:type", String)
], OnboardingApplicationReference$1.prototype, "applicationType", void 0);
__decorate$I([
    Property({ type: ONBOARDING_APPLICATION_STATUS$1 }),
    __metadata$I("design:type", String)
], OnboardingApplicationReference$1.prototype, "applicationStatus", void 0);

var ONBOARDING_STATUS$1;
(function (ONBOARDING_STATUS) {
    ONBOARDING_STATUS["OPEN"] = "OPEN";
    ONBOARDING_STATUS["CLOSED"] = "CLOSED";
})(ONBOARDING_STATUS$1 || (ONBOARDING_STATUS$1 = {}));

var __decorate$H = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$H = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Onboarding$1 extends BaseModel {
}
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "id", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "created", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "modified", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "activated", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "userId", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "firstName", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "lastName", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "userIdentifier", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "email", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "phone", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "assignUserId", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", Boolean)
], Onboarding$1.prototype, "supportActionable", void 0);
__decorate$H([
    Property(),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "callbackTime", void 0);
__decorate$H([
    Property({ type: ONBOARDING_STATUS$1 }),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "status", void 0);
__decorate$H([
    Property({ type: ONBOARDING_TRACK$1 }),
    __metadata$H("design:type", String)
], Onboarding$1.prototype, "track", void 0);
__decorate$H([
    Property({ type: OnboardingApplicationReference$1 }),
    __metadata$H("design:type", Array)
], Onboarding$1.prototype, "applications", void 0);

var ONBOARDING_APPLICATION_ACTION$1;
(function (ONBOARDING_APPLICATION_ACTION) {
    ONBOARDING_APPLICATION_ACTION["USER"] = "USER";
    ONBOARDING_APPLICATION_ACTION["SUPPORT"] = "SUPPORT";
})(ONBOARDING_APPLICATION_ACTION$1 || (ONBOARDING_APPLICATION_ACTION$1 = {}));

var __decorate$G = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$G = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplication$1 extends BaseModel {
}
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "id", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "onboardingId", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "created", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "modified", void 0);
__decorate$G([
    Property({ type: ONBOARDING_APPLICATION_STATUS$1 }),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "status", void 0);
__decorate$G([
    Property({ type: ONBOARDING_APPLICATION_TYPE$1 }),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "type", void 0);
__decorate$G([
    Property({ type: ONBOARDING_APPLICATION_ACTION$1 }),
    __metadata$G("design:type", String)
], OnboardingApplication$1.prototype, "action", void 0);
__decorate$G([
    Property(),
    __metadata$G("design:type", OnboardingApplicationData$1)
], OnboardingApplication$1.prototype, "data", void 0);

var __decorate$F = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$F = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationListResponse$1 extends BaseModel {
}
__decorate$F([
    Property({ type: OnboardingApplication$1 }),
    __metadata$F("design:type", Array)
], OnboardingApplicationListResponse$1.prototype, "data", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", Number)
], OnboardingApplicationListResponse$1.prototype, "length", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", Number)
], OnboardingApplicationListResponse$1.prototype, "offset", void 0);
__decorate$F([
    Property(),
    __metadata$F("design:type", Number)
], OnboardingApplicationListResponse$1.prototype, "total", void 0);

var __decorate$E = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$E = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationUpdateRequest$1 extends BaseModel {
}
__decorate$E([
    Property(),
    __metadata$E("design:type", Object)
], OnboardingApplicationUpdateRequest$1.prototype, "data", void 0);

var __decorate$D = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$D = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingCreateRequest$1 extends BaseModel {
}
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], OnboardingCreateRequest$1.prototype, "userId", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], OnboardingCreateRequest$1.prototype, "email", void 0);
__decorate$D([
    Property(),
    __metadata$D("design:type", String)
], OnboardingCreateRequest$1.prototype, "phone", void 0);

var __decorate$C = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$C = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingListResponse$1 extends BaseModel {
}
__decorate$C([
    Property({ type: Onboarding$1 }),
    __metadata$C("design:type", Array)
], OnboardingListResponse$1.prototype, "data", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], OnboardingListResponse$1.prototype, "length", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], OnboardingListResponse$1.prototype, "offset", void 0);
__decorate$C([
    Property(),
    __metadata$C("design:type", Number)
], OnboardingListResponse$1.prototype, "total", void 0);

var ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE;
(function (ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE) {
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["CEO"] = "CEO";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["BOARD_MEMBER"] = "BOARD_MEMBER";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["CHAIRMAN"] = "CHAIRMAN";
    ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE["ALTERNATE_MEMBER"] = "ALTERNATE_MEMBER";
})(ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE || (ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE = {}));

var __decorate$B = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$B = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationBoardMember extends BaseModel {
}
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], OnboardingApplicationBoardMember.prototype, "identifier", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], OnboardingApplicationBoardMember.prototype, "firstName", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", String)
], OnboardingApplicationBoardMember.prototype, "lastName", void 0);
__decorate$B([
    Property({ type: ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE }),
    __metadata$B("design:type", String)
], OnboardingApplicationBoardMember.prototype, "role", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Boolean)
], OnboardingApplicationBoardMember.prototype, "isCeo", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Boolean)
], OnboardingApplicationBoardMember.prototype, "isChairman", void 0);
__decorate$B([
    Property(),
    __metadata$B("design:type", Address)
], OnboardingApplicationBoardMember.prototype, "address", void 0);

var __decorate$A = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$A = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationBusinessOperationCode extends BaseModel {
}
__decorate$A([
    Property(),
    __metadata$A("design:type", String)
], OnboardingApplicationBusinessOperationCode.prototype, "businessOperationCode", void 0);
__decorate$A([
    Property(),
    __metadata$A("design:type", Number)
], OnboardingApplicationBusinessOperationCode.prototype, "revenue", void 0);

class OnboardingApplicationData extends BaseModel {
    validate() {
        return null;
    }
}

class OnboardingApplicationDataValidationError {
    constructor() {
        this._errors = {};
    }
    requireTrue(key, data) {
        if (data[key] !== true) {
            this._errors[key] = `ValidationError: ${key} is not true`;
        }
    }
    hasErrors() {
        return Object.keys(this._errors).length !== 0;
    }
    toString() {
        return Object.values(this._errors).join(',');
    }
}

var __decorate$z = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$z = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataTermsOfService extends OnboardingApplicationData {
    validate() {
        const err = new OnboardingApplicationDataValidationError();
        err.requireTrue('termsAndConditions', this);
        // err.requireTrue('creditCardAgreement', this);
        return err.hasErrors() ? err : null;
    }
}
__decorate$z([
    Property(),
    __metadata$z("design:type", Boolean)
], OnboardingApplicationDataTermsOfService.prototype, "termsAndConditions", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", Boolean)
], OnboardingApplicationDataTermsOfService.prototype, "creditCardAgreement", void 0);
__decorate$z([
    Property(),
    __metadata$z("design:type", String)
], OnboardingApplicationDataTermsOfService.prototype, "voucherCode", void 0);

var __decorate$y = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$y = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingActivate extends OnboardingApplicationData {
}
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], OnboardingApplicationDataExistingActivate.prototype, "companyId", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], OnboardingApplicationDataExistingActivate.prototype, "employerPermitGranted", void 0);
__decorate$y([
    Property({ type: COMPANY_STATUS }),
    __metadata$y("design:type", String)
], OnboardingApplicationDataExistingActivate.prototype, "companyStatus", void 0);
__decorate$y([
    Property(),
    __metadata$y("design:type", String)
], OnboardingApplicationDataExistingActivate.prototype, "vatStartDate", void 0);
__decorate$y([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$y("design:type", String)
], OnboardingApplicationDataExistingActivate.prototype, "vatInterval", void 0);

var __decorate$x = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$x = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingCompanyInfo extends OnboardingApplicationData {
}
__decorate$x([
    Property(),
    __metadata$x("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "companyIdentifier", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "companyName", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "companyDescription", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", String)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "firstFiscalYearStartDate", void 0);
__decorate$x([
    Property(),
    __metadata$x("design:type", Address)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "address", void 0);
__decorate$x([
    Property({ type: OnboardingApplicationBusinessOperationCode }),
    __metadata$x("design:type", Array)
], OnboardingApplicationDataExistingCompanyInfo.prototype, "businessOperationCodes", void 0);

var ONBOARDING_SIE_STATUS;
(function (ONBOARDING_SIE_STATUS) {
    ONBOARDING_SIE_STATUS["OK"] = "OK";
    ONBOARDING_SIE_STATUS["ERROR"] = "ERROR";
})(ONBOARDING_SIE_STATUS || (ONBOARDING_SIE_STATUS = {}));

var __decorate$w = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$w = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingCreateCompany extends OnboardingApplicationData {
}
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "companyId", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "companyName", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "companyIdentifier", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "companyDescription", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "businessOperationCode", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "firstFiscalYearStartDate", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Boolean)
], OnboardingApplicationDataExistingCreateCompany.prototype, "kycCheck", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Boolean)
], OnboardingApplicationDataExistingCreateCompany.prototype, "rdcCheck", void 0);
__decorate$w([
    Property(),
    __metadata$w("design:type", Address)
], OnboardingApplicationDataExistingCreateCompany.prototype, "address", void 0);
__decorate$w([
    Property({ type: SieValidatedFiscalYear }),
    __metadata$w("design:type", Array)
], OnboardingApplicationDataExistingCreateCompany.prototype, "fiscalYears", void 0);
__decorate$w([
    Property({ type: ONBOARDING_SIE_STATUS }),
    __metadata$w("design:type", String)
], OnboardingApplicationDataExistingCreateCompany.prototype, "sieStatus", void 0);

var __decorate$v = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$v = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcExistingDocuments extends OnboardingApplicationData {
}
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments.prototype, "corporateRegistrationAssetId", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments.prototype, "corporateRegistrationRecordAssetId", void 0);
__decorate$v([
    Property(),
    __metadata$v("design:type", String)
], OnboardingApplicationDataLlcExistingDocuments.prototype, "annualReportAssetId", void 0);

var __decorate$u = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$u = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingSettlement extends OnboardingApplicationData {
}
__decorate$u([
    Property(),
    __metadata$u("design:type", String)
], OnboardingApplicationDataExistingSettlement.prototype, "companyId", void 0);
__decorate$u([
    Property(),
    __metadata$u("design:type", String)
], OnboardingApplicationDataExistingSettlement.prototype, "ocr", void 0);
__decorate$u([
    Property(),
    __metadata$u("design:type", Amount)
], OnboardingApplicationDataExistingSettlement.prototype, "settlementAmount", void 0);
__decorate$u([
    Property(),
    __metadata$u("design:type", Amount)
], OnboardingApplicationDataExistingSettlement.prototype, "receivedSettlementAmount", void 0);

var __decorate$t = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$t = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataExistingSie extends OnboardingApplicationData {
}
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], OnboardingApplicationDataExistingSie.prototype, "sieAssetId", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], OnboardingApplicationDataExistingSie.prototype, "fiscalYearStartDate", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], OnboardingApplicationDataExistingSie.prototype, "fiscalYearEndDate", void 0);
__decorate$t([
    Property(),
    __metadata$t("design:type", String)
], OnboardingApplicationDataExistingSie.prototype, "companyIdentifier", void 0);
__decorate$t([
    Property({ type: String }),
    __metadata$t("design:type", Array)
], OnboardingApplicationDataExistingSie.prototype, "errors", void 0);
__decorate$t([
    Property({ type: ONBOARDING_SIE_STATUS }),
    __metadata$t("design:type", String)
], OnboardingApplicationDataExistingSie.prototype, "sieStatus", void 0);

var __decorate$s = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$s = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewActivate extends OnboardingApplicationData {
}
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "companyId", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "companyIdentifier", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "companyName", void 0);
__decorate$s([
    Property({ type: COMPANY_STATUS }),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "companyStatus", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "fiscalYearStartDate", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "fiscalYearEndDate", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "employerPermitGranted", void 0);
__decorate$s([
    Property(),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "vatStartDate", void 0);
__decorate$s([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$s("design:type", String)
], OnboardingApplicationDataLlcNewActivate.prototype, "vatInterval", void 0);

var __decorate$r = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$r = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewApplicationBlv extends OnboardingApplicationData {
}
__decorate$r([
    Property(),
    __metadata$r("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv.prototype, "companyName", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv.prototype, "companyRegistrationAssetId", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv.prototype, "blvAckAssetId", void 0);
__decorate$r([
    Property(),
    __metadata$r("design:type", String)
], OnboardingApplicationDataLlcNewApplicationBlv.prototype, "blvCaseNumber", void 0);

var __decorate$q = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$q = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewApplicationSkv extends OnboardingApplicationData {
}
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], OnboardingApplicationDataLlcNewApplicationSkv.prototype, "companyStartDate", void 0);
__decorate$q([
    Property(),
    __metadata$q("design:type", String)
], OnboardingApplicationDataLlcNewApplicationSkv.prototype, "skvAckAssetId", void 0);

var __decorate$p = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$p = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvBoardForm extends OnboardingApplicationData {
}
__decorate$p([
    Property({ type: OnboardingApplicationBoardMember }),
    __metadata$p("design:type", Array)
], OnboardingApplicationDataLlcNewBlvBoardForm.prototype, "boardMembers", void 0);

var __decorate$o = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$o = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvForm extends OnboardingApplicationData {
}
__decorate$o([
    Property(),
    __metadata$o("design:type", String)
], OnboardingApplicationDataLlcNewBlvForm.prototype, "email", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", Address)
], OnboardingApplicationDataLlcNewBlvForm.prototype, "address", void 0);
__decorate$o([
    Property({ type: String }),
    __metadata$o("design:type", Array)
], OnboardingApplicationDataLlcNewBlvForm.prototype, "nameSuggestions", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", Boolean)
], OnboardingApplicationDataLlcNewBlvForm.prototype, "isCEO", void 0);
__decorate$o([
    Property(),
    __metadata$o("design:type", Boolean)
], OnboardingApplicationDataLlcNewBlvForm.prototype, "isBeneficialOwner", void 0);

var __decorate$n = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$n = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewBlvSharesForm extends OnboardingApplicationData {
}
__decorate$n([
    Property(),
    __metadata$n("design:type", Stock)
], OnboardingApplicationDataLlcNewBlvSharesForm.prototype, "stock", void 0);
__decorate$n([
    Property({ type: Shareholder }),
    __metadata$n("design:type", Array)
], OnboardingApplicationDataLlcNewBlvSharesForm.prototype, "shareholders", void 0);

var __decorate$m = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$m = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewCreateCompany extends OnboardingApplicationData {
}
__decorate$m([
    Property(),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "companyId", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "companyIdentifier", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "companyName", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "companyDescription", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "registrationDate", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", Boolean)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "kycCheck", void 0);
__decorate$m([
    Property(),
    __metadata$m("design:type", Boolean)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "rdcCheck", void 0);
__decorate$m([
    Property({ type: COUNTRY }),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "companyCountry", void 0);
__decorate$m([
    Property({ type: COMPANY_FISCAL_YEAR_LENGTH }),
    __metadata$m("design:type", String)
], OnboardingApplicationDataLlcNewCreateCompany.prototype, "firstFiscalYear", void 0);

var __decorate$l = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$l = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewShareCapital extends OnboardingApplicationData {
}
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "shareHolderCapital", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", Amount)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "receivedShareHolderCapital", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "ocr", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "companyId", void 0);
__decorate$l([
    Property(),
    __metadata$l("design:type", String)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "shareHolderNoteAssetId", void 0);
__decorate$l([
    Property({ type: String }),
    __metadata$l("design:type", Array)
], OnboardingApplicationDataLlcNewShareCapital.prototype, "listOfShareHolderNoteAssetIds", void 0);

var __decorate$k = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$k = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataLlcNewSkvForm extends OnboardingApplicationData {
}
__decorate$k([
    Property(),
    __metadata$k("design:type", String)
], OnboardingApplicationDataLlcNewSkvForm.prototype, "companyDescription", void 0);
__decorate$k([
    Property({ type: OnboardingApplicationBusinessOperationCode }),
    __metadata$k("design:type", Array)
], OnboardingApplicationDataLlcNewSkvForm.prototype, "businessOperationCodes", void 0);

var __decorate$j = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$j = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleExistingDocuments extends OnboardingApplicationData {
}
__decorate$j([
    Property(),
    __metadata$j("design:type", String)
], OnboardingApplicationDataSoleExistingDocuments.prototype, "corporateRegistrationRecordAssetId", void 0);

var __decorate$i = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$i = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewActivate extends OnboardingApplicationData {
}
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "companyId", void 0);
__decorate$i([
    Property({ type: COMPANY_STATUS }),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "companyStatus", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "fiscalYearStartDate", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "fiscalYearEndDate", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "employerPermitGranted", void 0);
__decorate$i([
    Property(),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "vatStartDate", void 0);
__decorate$i([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$i("design:type", String)
], OnboardingApplicationDataSoleNewActivate.prototype, "vatInterval", void 0);

var __decorate$h = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$h = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewApplicationSkv extends OnboardingApplicationData {
}
__decorate$h([
    Property(),
    __metadata$h("design:type", String)
], OnboardingApplicationDataSoleNewApplicationSkv.prototype, "companyStartDate", void 0);
__decorate$h([
    Property(),
    __metadata$h("design:type", String)
], OnboardingApplicationDataSoleNewApplicationSkv.prototype, "skvAckAssetId", void 0);

var __decorate$g = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$g = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewCreateCompany extends OnboardingApplicationData {
}
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "companyId", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "companyIdentifier", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "companyName", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "companyDescription", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "registrationDate", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", Boolean)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "kycCheck", void 0);
__decorate$g([
    Property(),
    __metadata$g("design:type", Boolean)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "rdcCheck", void 0);
__decorate$g([
    Property({ type: COUNTRY }),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "companyCountry", void 0);
__decorate$g([
    Property({ type: COMPANY_FISCAL_YEAR_LENGTH }),
    __metadata$g("design:type", String)
], OnboardingApplicationDataSoleNewCreateCompany.prototype, "firstFiscalYear", void 0);

var __decorate$f = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$f = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationDataSoleNewSkvForm extends OnboardingApplicationData {
}
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "companyDescription", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "previousSalary", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "previousTaxes", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "previousOtherIncome", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "salary", void 0);
__decorate$f([
    Property(),
    __metadata$f("design:type", String)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "otherIncome", void 0);
__decorate$f([
    Property({ type: OnboardingApplicationBusinessOperationCode }),
    __metadata$f("design:type", Array)
], OnboardingApplicationDataSoleNewSkvForm.prototype, "businessOperationCodes", void 0);

var ONBOARDING_TRACK;
(function (ONBOARDING_TRACK) {
    ONBOARDING_TRACK["SOLE_TRADER_NEW"] = "SOLE_TRADER_NEW";
    ONBOARDING_TRACK["SOLE_TRADER_EXISTING"] = "SOLE_TRADER_EXISTING";
    ONBOARDING_TRACK["LIMITED_COMPANY_NEW"] = "LIMITED_COMPANY_NEW";
    ONBOARDING_TRACK["LIMITED_COMPANY_EXISTING"] = "LIMITED_COMPANY_EXISTING";
    ONBOARDING_TRACK["NONE"] = "NONE";
})(ONBOARDING_TRACK || (ONBOARDING_TRACK = {}));

var ONBOARDING_APPLICATION_TYPE;
(function (ONBOARDING_APPLICATION_TYPE) {
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_COMPANY_INFO"] = "LIMITED_COMPANY_EXISTING_COMPANY_INFO";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_DOCUMENTS"] = "LIMITED_COMPANY_EXISTING_DOCUMENTS";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_SIE"] = "LIMITED_COMPANY_EXISTING_SIE";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_CREATE_COMPANY"] = "LIMITED_COMPANY_EXISTING_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_SETTLEMENT"] = "LIMITED_COMPANY_EXISTING_SETTLEMENT";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_EXISTING_ACTIVATE"] = "LIMITED_COMPANY_EXISTING_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_FORM"] = "LIMITED_COMPANY_NEW_BLV_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_BOARD_FORM"] = "LIMITED_COMPANY_NEW_BLV_BOARD_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_BLV_SHARES_FORM"] = "LIMITED_COMPANY_NEW_BLV_SHARES_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_SKV_FORM"] = "LIMITED_COMPANY_NEW_SKV_FORM";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_SHARE_CAPITAL"] = "LIMITED_COMPANY_NEW_SHARE_CAPITAL";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_APPLICATION_BLV"] = "LIMITED_COMPANY_NEW_APPLICATION_BLV";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_APPLICATION_SKV"] = "LIMITED_COMPANY_NEW_APPLICATION_SKV";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_CREATE_COMPANY"] = "LIMITED_COMPANY_NEW_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["LIMITED_COMPANY_NEW_ACTIVATE"] = "LIMITED_COMPANY_NEW_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_COMPANY_INFO"] = "SOLE_TRADER_EXISTING_COMPANY_INFO";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_DOCUMENTS"] = "SOLE_TRADER_EXISTING_DOCUMENTS";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_SIE"] = "SOLE_TRADER_EXISTING_SIE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_CREATE_COMPANY"] = "SOLE_TRADER_EXISTING_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_SETTLEMENT"] = "SOLE_TRADER_EXISTING_SETTLEMENT";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_EXISTING_ACTIVATE"] = "SOLE_TRADER_EXISTING_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_SKV_FORM"] = "SOLE_TRADER_NEW_SKV_FORM";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_CREATE_COMPANY"] = "SOLE_TRADER_NEW_CREATE_COMPANY";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_APPLICATION_SKV"] = "SOLE_TRADER_NEW_APPLICATION_SKV";
    ONBOARDING_APPLICATION_TYPE["SOLE_TRADER_NEW_ACTIVATE"] = "SOLE_TRADER_NEW_ACTIVATE";
    ONBOARDING_APPLICATION_TYPE["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
})(ONBOARDING_APPLICATION_TYPE || (ONBOARDING_APPLICATION_TYPE = {}));

var ONBOARDING_APPLICATION_STATUS;
(function (ONBOARDING_APPLICATION_STATUS) {
    ONBOARDING_APPLICATION_STATUS["DRAFT"] = "DRAFT";
    ONBOARDING_APPLICATION_STATUS["SENT"] = "SENT";
    ONBOARDING_APPLICATION_STATUS["DONE"] = "DONE";
})(ONBOARDING_APPLICATION_STATUS || (ONBOARDING_APPLICATION_STATUS = {}));

var __decorate$e = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$e = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationReference extends BaseModel {
}
__decorate$e([
    Property(),
    __metadata$e("design:type", String)
], OnboardingApplicationReference.prototype, "applicationId", void 0);
__decorate$e([
    Property({ type: ONBOARDING_APPLICATION_TYPE }),
    __metadata$e("design:type", String)
], OnboardingApplicationReference.prototype, "applicationType", void 0);
__decorate$e([
    Property({ type: ONBOARDING_APPLICATION_STATUS }),
    __metadata$e("design:type", String)
], OnboardingApplicationReference.prototype, "applicationStatus", void 0);

var ONBOARDING_STATUS;
(function (ONBOARDING_STATUS) {
    ONBOARDING_STATUS["OPEN"] = "OPEN";
    ONBOARDING_STATUS["CLOSED"] = "CLOSED";
})(ONBOARDING_STATUS || (ONBOARDING_STATUS = {}));

var __decorate$d = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$d = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class Onboarding extends BaseModel {
}
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "id", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "created", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "modified", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "activated", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "userId", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "firstName", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "lastName", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "userIdentifier", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "email", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "phone", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "assignUserId", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", Boolean)
], Onboarding.prototype, "supportActionable", void 0);
__decorate$d([
    Property(),
    __metadata$d("design:type", String)
], Onboarding.prototype, "callbackTime", void 0);
__decorate$d([
    Property({ type: ONBOARDING_STATUS }),
    __metadata$d("design:type", String)
], Onboarding.prototype, "status", void 0);
__decorate$d([
    Property({ type: ONBOARDING_TRACK }),
    __metadata$d("design:type", String)
], Onboarding.prototype, "track", void 0);
__decorate$d([
    Property({ type: OnboardingApplicationReference }),
    __metadata$d("design:type", Array)
], Onboarding.prototype, "applications", void 0);

var ONBOARDING_APPLICATION_ACTION;
(function (ONBOARDING_APPLICATION_ACTION) {
    ONBOARDING_APPLICATION_ACTION["USER"] = "USER";
    ONBOARDING_APPLICATION_ACTION["SUPPORT"] = "SUPPORT";
})(ONBOARDING_APPLICATION_ACTION || (ONBOARDING_APPLICATION_ACTION = {}));

var __decorate$c = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$c = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplication extends BaseModel {
}
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "id", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "onboardingId", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "created", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "modified", void 0);
__decorate$c([
    Property({ type: ONBOARDING_APPLICATION_STATUS }),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "status", void 0);
__decorate$c([
    Property({ type: ONBOARDING_APPLICATION_TYPE }),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "type", void 0);
__decorate$c([
    Property({ type: ONBOARDING_APPLICATION_ACTION }),
    __metadata$c("design:type", String)
], OnboardingApplication.prototype, "action", void 0);
__decorate$c([
    Property(),
    __metadata$c("design:type", OnboardingApplicationData)
], OnboardingApplication.prototype, "data", void 0);

var __decorate$b = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$b = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationListResponse extends BaseModel {
}
__decorate$b([
    Property({ type: OnboardingApplication }),
    __metadata$b("design:type", Array)
], OnboardingApplicationListResponse.prototype, "data", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Number)
], OnboardingApplicationListResponse.prototype, "length", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Number)
], OnboardingApplicationListResponse.prototype, "offset", void 0);
__decorate$b([
    Property(),
    __metadata$b("design:type", Number)
], OnboardingApplicationListResponse.prototype, "total", void 0);

var __decorate$a = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$a = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingApplicationUpdateRequest extends BaseModel {
}
__decorate$a([
    Property(),
    __metadata$a("design:type", Object)
], OnboardingApplicationUpdateRequest.prototype, "data", void 0);

var __decorate$9 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$9 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingCreateRequest extends BaseModel {
}
__decorate$9([
    Property(),
    __metadata$9("design:type", String)
], OnboardingCreateRequest.prototype, "userId", void 0);
__decorate$9([
    Property(),
    __metadata$9("design:type", String)
], OnboardingCreateRequest.prototype, "email", void 0);
__decorate$9([
    Property(),
    __metadata$9("design:type", String)
], OnboardingCreateRequest.prototype, "phone", void 0);

var __decorate$8 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$8 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingListResponse extends BaseModel {
}
__decorate$8([
    Property({ type: Onboarding }),
    __metadata$8("design:type", Array)
], OnboardingListResponse.prototype, "data", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Number)
], OnboardingListResponse.prototype, "length", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Number)
], OnboardingListResponse.prototype, "offset", void 0);
__decorate$8([
    Property(),
    __metadata$8("design:type", Number)
], OnboardingListResponse.prototype, "total", void 0);

var __decorate$7 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$7 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingSummaryTrack$1 extends BaseModel {
}
__decorate$7([
    Property({ type: ONBOARDING_TRACK }),
    __metadata$7("design:type", String)
], OnboardingSummaryTrack$1.prototype, "track", void 0);
__decorate$7([
    Property(),
    __metadata$7("design:type", Number)
], OnboardingSummaryTrack$1.prototype, "count", void 0);

var __decorate$6 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$6 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingSummary$1 extends BaseModel {
}
__decorate$6([
    Property({ type: OnboardingSummaryTrack$1 }),
    __metadata$6("design:type", Array)
], OnboardingSummary$1.prototype, "tracks", void 0);

var __decorate$5 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$5 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingUpdateRequest$1 extends BaseModel {
}
__decorate$5([
    Property(),
    __metadata$5("design:type", String)
], OnboardingUpdateRequest$1.prototype, "callbackTime", void 0);

var __decorate$4 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$4 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class UpdateVatIntervalRequest$1 extends BaseModel {
}
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], UpdateVatIntervalRequest$1.prototype, "companyId", void 0);
__decorate$4([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata$4("design:type", String)
], UpdateVatIntervalRequest$1.prototype, "vatInterval", void 0);
__decorate$4([
    Property(),
    __metadata$4("design:type", String)
], UpdateVatIntervalRequest$1.prototype, "vatStartDate", void 0);

var __decorate$3 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$3 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingSummaryTrack extends BaseModel {
}
__decorate$3([
    Property({ type: ONBOARDING_TRACK }),
    __metadata$3("design:type", String)
], OnboardingSummaryTrack.prototype, "track", void 0);
__decorate$3([
    Property(),
    __metadata$3("design:type", Number)
], OnboardingSummaryTrack.prototype, "count", void 0);

var __decorate$2 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingSummary extends BaseModel {
}
__decorate$2([
    Property({ type: OnboardingSummaryTrack }),
    __metadata$2("design:type", Array)
], OnboardingSummary.prototype, "tracks", void 0);

var __decorate$1 = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class OnboardingUpdateRequest extends BaseModel {
}
__decorate$1([
    Property(),
    __metadata$1("design:type", String)
], OnboardingUpdateRequest.prototype, "callbackTime", void 0);

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class UpdateVatIntervalRequest extends BaseModel {
}
__decorate([
    Property(),
    __metadata("design:type", String)
], UpdateVatIntervalRequest.prototype, "companyId", void 0);
__decorate([
    Property({ type: COMPANY_PERIOD_INTERVAL }),
    __metadata("design:type", String)
], UpdateVatIntervalRequest.prototype, "vatInterval", void 0);
__decorate([
    Property(),
    __metadata("design:type", String)
], UpdateVatIntervalRequest.prototype, "vatStartDate", void 0);

class OnboardingApplicationFactory {
    static create(applicationType, data) {
        const application = new OnboardingApplication$1();
        application.type = applicationType;
        switch (applicationType) {
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_COMPANY_INFO:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingCompanyInfo$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_DOCUMENTS:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcExistingDocuments$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_SIE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingSie$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_CREATE_COMPANY:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataExistingCreateCompany$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_SETTLEMENT:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingSettlement$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_EXISTING_ACTIVATE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataExistingActivate$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_BLV_FORM:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcNewBlvForm$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_BLV_BOARD_FORM:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcNewBlvBoardForm$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_BLV_SHARES_FORM:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcNewBlvSharesForm$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_SKV_FORM:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcNewSkvForm$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_SHARE_CAPITAL:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataLlcNewShareCapital$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_APPLICATION_BLV:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataLlcNewApplicationBlv$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_APPLICATION_SKV:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataLlcNewApplicationSkv$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_CREATE_COMPANY:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataLlcNewCreateCompany$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.LIMITED_COMPANY_NEW_ACTIVATE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataLlcNewActivate$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_COMPANY_INFO:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingCompanyInfo$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_DOCUMENTS:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataSoleExistingDocuments$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_SIE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingSie$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_CREATE_COMPANY:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataExistingCreateCompany$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_SETTLEMENT:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataExistingSettlement$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_EXISTING_ACTIVATE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataExistingActivate$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_NEW_SKV_FORM:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataSoleNewSkvForm$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_NEW_CREATE_COMPANY:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataSoleNewCreateCompany$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_NEW_APPLICATION_SKV:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataSoleNewApplicationSkv$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.SOLE_TRADER_NEW_ACTIVATE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.SUPPORT;
                application.data = new OnboardingApplicationDataSoleNewActivate$1(data);
                break;
            case ONBOARDING_APPLICATION_TYPE$1.TERMS_OF_SERVICE:
                application.action = ONBOARDING_APPLICATION_ACTION$1.USER;
                application.data = new OnboardingApplicationDataTermsOfService$1(data);
                break;
        }
        return application;
    }
}

export { ONBOARDING_APPLICATION_ACTION$1 as ONBOARDING_APPLICATION_ACTION, ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE$1 as ONBOARDING_APPLICATION_BOARD_MEMBER_ROLE, ONBOARDING_APPLICATION_STATUS$1 as ONBOARDING_APPLICATION_STATUS, ONBOARDING_APPLICATION_TYPE$1 as ONBOARDING_APPLICATION_TYPE, ONBOARDING_SIE_STATUS$1 as ONBOARDING_SIE_STATUS, ONBOARDING_STATUS$1 as ONBOARDING_STATUS, ONBOARDING_TRACK$1 as ONBOARDING_TRACK, Onboarding$1 as Onboarding, OnboardingApplication$1 as OnboardingApplication, OnboardingApplicationBoardMember$1 as OnboardingApplicationBoardMember, OnboardingApplicationBusinessOperationCode$1 as OnboardingApplicationBusinessOperationCode, OnboardingApplicationData$1 as OnboardingApplicationData, OnboardingApplicationDataExistingActivate$1 as OnboardingApplicationDataExistingActivate, OnboardingApplicationDataExistingCompanyInfo$1 as OnboardingApplicationDataExistingCompanyInfo, OnboardingApplicationDataExistingCreateCompany$1 as OnboardingApplicationDataExistingCreateCompany, OnboardingApplicationDataExistingSettlement$1 as OnboardingApplicationDataExistingSettlement, OnboardingApplicationDataExistingSie$1 as OnboardingApplicationDataExistingSie, OnboardingApplicationDataLlcExistingDocuments$1 as OnboardingApplicationDataLlcExistingDocuments, OnboardingApplicationDataLlcNewActivate$1 as OnboardingApplicationDataLlcNewActivate, OnboardingApplicationDataLlcNewApplicationBlv$1 as OnboardingApplicationDataLlcNewApplicationBlv, OnboardingApplicationDataLlcNewApplicationSkv$1 as OnboardingApplicationDataLlcNewApplicationSkv, OnboardingApplicationDataLlcNewBlvBoardForm$1 as OnboardingApplicationDataLlcNewBlvBoardForm, OnboardingApplicationDataLlcNewBlvForm$1 as OnboardingApplicationDataLlcNewBlvForm, OnboardingApplicationDataLlcNewBlvSharesForm$1 as OnboardingApplicationDataLlcNewBlvSharesForm, OnboardingApplicationDataLlcNewCreateCompany$1 as OnboardingApplicationDataLlcNewCreateCompany, OnboardingApplicationDataLlcNewShareCapital$1 as OnboardingApplicationDataLlcNewShareCapital, OnboardingApplicationDataLlcNewSkvForm$1 as OnboardingApplicationDataLlcNewSkvForm, OnboardingApplicationDataSoleExistingDocuments$1 as OnboardingApplicationDataSoleExistingDocuments, OnboardingApplicationDataSoleNewActivate$1 as OnboardingApplicationDataSoleNewActivate, OnboardingApplicationDataSoleNewApplicationSkv$1 as OnboardingApplicationDataSoleNewApplicationSkv, OnboardingApplicationDataSoleNewCreateCompany$1 as OnboardingApplicationDataSoleNewCreateCompany, OnboardingApplicationDataSoleNewSkvForm$1 as OnboardingApplicationDataSoleNewSkvForm, OnboardingApplicationDataTermsOfService$1 as OnboardingApplicationDataTermsOfService, OnboardingApplicationDataValidationError$1 as OnboardingApplicationDataValidationError, OnboardingApplicationFactory, OnboardingApplicationListResponse$1 as OnboardingApplicationListResponse, OnboardingApplicationReference$1 as OnboardingApplicationReference, OnboardingApplicationUpdateRequest$1 as OnboardingApplicationUpdateRequest, OnboardingCreateRequest$1 as OnboardingCreateRequest, OnboardingListResponse$1 as OnboardingListResponse, OnboardingSummary, OnboardingSummaryTrack, OnboardingUpdateRequest, UpdateVatIntervalRequest };
